import moment from 'moment'
import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendUserDetails, updateUserRequest } from '../../../redux/slices'

const formFields = [
  {
    name: 'name',
    label: 'Name',
    placeholder: 'Enter your name',
    autoFocus: true,
    validation: {
      required: 'Name is required',
      minLength: {
        value: 3,
        message: 'Name should be at least 5 characters long',
      },
    },
  },
  {
    name: 'dob',
    label: 'Date of Birth',
    placeholder: 'Select your date of birth',
    inputType: 'date',
    validation: {
      required: 'Date of birth is required',
    },
  },
  {
    name: 'gender',
    label: 'Gender',
    placeholder: 'Select gender',
    type: 'number',
    minLength: 6,
    maxLength: 6,
    inputType: 'radio',
    options: [
      {
        label: 'Male',
        val: 'M',
      },
      {
        label: 'Female',
        val: 'F',
      },
      {
        label: 'Others',
        val: 'O',
      },
    ],
    validation: {
      required: 'Gender is required',
    },
  },
]

const useAddUserDetails = () => {
  const { loading, success, error } = useSelector(
    (state) => state.auth.updateUserDetails,
  )
  const { userDetails } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [detailsUpdated, setDetailsUpdated] = useState(false)

  const onAddUserDetails = (payload) => {
    const { dob, ...restPayload } = payload
    const formattedDob = moment(dob).format('YYYY-MM-DD')
    const finalPayload = {
      dob: formattedDob,
      ...restPayload,
    }
    dispatch(updateUserRequest(finalPayload))
    dispatch(appendUserDetails(finalPayload))
    setDetailsUpdated(true)
  }

  const onSubmit = (data) => {
    onAddUserDetails(data)
  }
  const defaultFormValues = useMemo(() => {
    return {
      name: userDetails?.data?.name || '',
      dob:
        userDetails?.data?.dob ||
        moment().subtract(18, 'years').format('YYYY-MM-DD'),
      gender: userDetails?.data?.gender || 'M',
    }
  }, [userDetails])

  return {
    error,
    loading,
    success,
    formFields,
    userDetails,
    detailsUpdated,
    defaultFormValues,
    onSubmit,
    onAddUserDetails,
  }
}
export default useAddUserDetails
